import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { MapPin, Phone, Clock, ExternalLink } from 'lucide-react';

export default function LocationSection() {
  const { t } = useLanguage();

  return (
    <section
      id="location"
      data-testid="location-section"
      className="section-padding bg-[#FBF9F6]"
    >
      <div className="section-container">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="overline mb-4">{t('location.overline')}</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-medium text-[#2A1E17]">
            {t('location.title')}
          </h2>
          <div className="w-20 h-[2px] bg-[#8C5A2B] mx-auto mt-6" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Map */}
          <div className="h-[400px] lg:h-[500px] border border-[#E6D8C8] overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.2678839785736!2d-8.117438924192997!3d37.0777589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad4ac0f4a6b45%3A0x8a7a9cf48bd2b839!2sRui&#39;s%20Restaurante!5e0!3m2!1sen!2spt!4v1704067200000!5m2!1sen!2spt"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Rui's Restaurante Location"
              data-testid="google-map"
            />
          </div>

          {/* Contact Info */}
          <div className="space-y-8">
            {/* Address */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#F0EAE1] flex items-center justify-center flex-shrink-0">
                <MapPin size={24} strokeWidth={1.5} className="text-[#8C5A2B]" />
              </div>
              <div>
                <h3 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#2A1E17] mb-2">
                  {t('location.address')}
                </h3>
                <p className="text-[#6B584B]">R. do Clube Náutico 4-5</p>
                <p className="text-[#6B584B]">8125-442 Quarteira</p>
                <p className="text-[#6B584B]">Vilamoura, Portugal</p>
              </div>
            </div>

            {/* Phone */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#F0EAE1] flex items-center justify-center flex-shrink-0">
                <Phone size={24} strokeWidth={1.5} className="text-[#8C5A2B]" />
              </div>
              <div>
                <h3 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#2A1E17] mb-2">
                  {t('location.callUs')}
                </h3>
                <a
                  href="tel:+351932815611"
                  data-testid="location-phone-link"
                  className="text-[#8C5A2B] hover:text-[#A8723E] transition-colors font-medium"
                >
                  +351 932 815 611
                </a>
              </div>
            </div>

            {/* Hours */}
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-[#F0EAE1] flex items-center justify-center flex-shrink-0">
                <Clock size={24} strokeWidth={1.5} className="text-[#8C5A2B]" />
              </div>
              <div>
                <h3 className="font-['Cormorant_Garamond'] text-xl font-medium text-[#2A1E17] mb-2">
                  {t('reservations.hours.title')}
                </h3>
                <div className="space-y-1 text-[#6B584B]">
                  <p><span className="font-medium">Monday:</span> Closed</p>
                  <p><span className="font-medium">Tuesday - Sunday:</span> 6 PM - 11 PM</p>
                </div>
              </div>
            </div>

            {/* Get Directions Button */}
            <a
              href="https://www.google.com/maps/dir//Rui's+Restaurante,+R.+do+Clube+N%C3%A1utico+4-5,+8125-442+Quarteira,+Portugal"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="get-directions-btn"
              className="btn-primary inline-flex items-center gap-2"
            >
              {t('location.directions')}
              <ExternalLink size={16} strokeWidth={1.5} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
